<div class="tt-page">

  <!-- ======================== HERO ======================== -->
  <section class="tt-hero">
    <div class="tt-hero-glow"></div>
    <div class="tt-wrap">
      <div class="tt-hero-inner">

        <!-- LEFT -->
        <div class="tt-hero-left">
          <div class="tt-hero-badge">
            <span class="tt-hero-badge-dot"></span>
            Weekly Topic Tests · 11+ Prep
          </div>
          <h1 class="tt-hero-title">
            Boost Your Child's<br>
            <em>11+ Success</em><br>
            Week by Week
          </h1>
          <p class="tt-hero-sub">Carefully structured weekly tests covering Maths, English, Creative Writing, VR &amp; NVR — systematically building confidence across the full syllabus from October to February. Conducted across Harrow, Ilford, Chelmsford, Basildon, Amersham, Milton Keynes and Bexley.</p>
          <div class="tt-hero-actions">
            <button class="tt-btn-primary" (click)="scrollToCalendar()">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Topic Test
            </button>
            <button class="tt-btn-outline" (click)="downloadCalendar()">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
              Download Schedule
            </button>
          </div>
          <div class="tt-hero-stats">
            <div class="tt-hero-stat">
              <div class="tt-stat-num">15</div>
              <div class="tt-stat-lbl">Week Programme</div>
            </div>
            <div class="tt-hero-stat">
              <div class="tt-stat-num">5+</div>
              <div class="tt-stat-lbl">UK Exam Boards</div>
            </div>
            <div class="tt-hero-stat">
              <div class="tt-stat-num">100%</div>
              <div class="tt-stat-lbl">Syllabus Coverage</div>
            </div>
          </div>
        </div>

        <!-- RIGHT — what's covered guide card -->
        <div class="tt-hero-right">
          <div class="tt-hero-guide">
            <div class="tt-guide-title">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
              15 Weeks · What You Get
            </div>

            <!-- Step-by-step mini guide -->
            <div class="tt-guide-steps">
              <div class="tt-gstep">
                <div class="tt-gstep-num">1</div>
                <div>
                  <div class="tt-gstep-label">Choose your session</div>
                  <div class="tt-gstep-sub">Filter by centre, board or mode below</div>
                </div>
              </div>
              <div class="tt-gstep">
                <div class="tt-gstep-num">2</div>
                <div>
                  <div class="tt-gstep-label">Book your spot</div>
                  <div class="tt-gstep-sub">Click the gold Book Now button — takes 60 seconds</div>
                </div>
              </div>
              <div class="tt-gstep">
                <div class="tt-gstep-num">3</div>
                <div>
                  <div class="tt-gstep-label">Sit the weekly test</div>
                  <div class="tt-gstep-sub">Online or face to face, Oct – Feb</div>
                </div>
              </div>
            </div>

            <!-- What's included highlights -->
            <div class="tt-guide-highlights">
              <div class="tt-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Maths · English · Creative Writing · VR &amp; NVR
              </div>
              <div class="tt-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                Result Analysis Report (RAR) after every test
              </div>
              <div class="tt-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                GL · CSSE · FSCE · CEM formats
              </div>
              <div class="tt-guide-hl">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
                7 centres across England
              </div>
            </div>

            <button class="tt-guide-cta" (click)="scrollToCalendar()">
              View All Sessions →
            </button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ======================== SUBJECTS ======================== -->
  <section class="tt-section tt-subjects" id="subjects">
    <div class="tt-wrap">
      <div class="tt-section-hd tt-section-hd--center">
        <div class="tt-tag">What We Cover</div>
        <h2 class="tt-section-title">Step-by-Step Preparation for 11+ Success</h2>
        <p class="tt-section-desc">Our weekly Topic Tests are crafted to help students gradually cover the entire 11+ syllabus.</p>
      </div>
      <div class="tt-subjects-grid">
        <div class="tt-subject-card">
          <div class="tt-subject-icon tt-ic-b">🔢</div>
          <div class="tt-subject-name">Maths</div>
          <div class="tt-subject-desc">Problem-solving &amp; reasoning skills across numbers, shapes, data and sequences.</div>
        </div>
        <div class="tt-subject-card">
          <div class="tt-subject-icon tt-ic-g">📖</div>
          <div class="tt-subject-name">English</div>
          <div class="tt-subject-desc">Reading comprehension, grammar mastery, vocabulary, cloze and literary analysis.</div>
        </div>
        <div class="tt-subject-card">
          <div class="tt-subject-icon tt-ic-p">✍️</div>
          <div class="tt-subject-name">Creative Writing</div>
          <div class="tt-subject-desc">Imagination &amp; expression through structured storytelling and composition.</div>
        </div>
        <div class="tt-subject-card">
          <div class="tt-subject-icon tt-ic-a">🧠</div>
          <div class="tt-subject-name">VR &amp; NVR</div>
          <div class="tt-subject-desc">Verbal &amp; Non-Verbal reasoning — logic, patterns, sequences and spatial thinking.</div>
        </div>
      </div>
      <p class="tt-subjects-note">These tests act as a warm-up before the full Mock Test series (March–September), allowing students to identify weak spots and build consistent confidence.</p>
    </div>
  </section>

  <!-- ======================== PROVEN RESULTS ======================== -->
  <section class="tt-section tt-results" id="results">
    <div class="tt-wrap">
      <div class="tt-section-hd tt-section-hd--center">
        <div class="tt-tag tt-tag--gold">Proven Results</div>
        <h2 class="tt-section-title tt-section-title--light">Trusted by Parents, Loved by Students</h2>
        <p class="tt-section-desc tt-section-desc--light">Historically, our Topic Tests have been highly recommended by alumni parents, with many students going on to achieve top results in 11+ exams.</p>
      </div>
      <div class="tt-results-grid">
        <div class="tt-result-item">
          <div class="tt-result-ico">🎯</div>
          <h3>Targeted</h3>
          <p>Practice</p>
        </div>
        <div class="tt-result-item">
          <div class="tt-result-ico">📈</div>
          <h3>Regular</h3>
          <p>Progress Tracking</p>
        </div>
        <div class="tt-result-item">
          <div class="tt-result-ico">💪</div>
          <h3>Confidence</h3>
          <p>Building Week by Week</p>
        </div>
      </div>
      <div class="tt-results-cta">
        <button class="tt-btn-primary" (click)="scrollToCalendar()">Book Topic Test</button>
      </div>
    </div>
  </section>

  <!-- ======================== HOW IT WORKS ======================== -->
  <section class="tt-section tt-how" id="how">
    <div class="tt-wrap">
      <div class="tt-section-hd tt-section-hd--center">
        <div class="tt-tag">Simple Process</div>
        <h2 class="tt-section-title tt-section-title--light">Get Started in 3 Easy Steps</h2>
        <p class="tt-section-desc tt-section-desc--light">From sign-up to your first test in minutes — no complex setup required.</p>
      </div>
      <div class="tt-steps-grid">
        <div class="tt-step">
          <div class="tt-step-num">01</div>
          <div class="tt-step-icon">📝</div>
          <h3>Sign Up</h3>
          <p>Quick registration online. Create your account in under two minutes.</p>
        </div>
        <div class="tt-step">
          <div class="tt-step-num">02</div>
          <div class="tt-step-icon">📅</div>
          <h3>Choose Your Plan</h3>
          <p>Select weekly tests for October–February aligned to your child's school term.</p>
        </div>
        <div class="tt-step">
          <div class="tt-step-num">03</div>
          <div class="tt-step-icon">🚀</div>
          <h3>Start Practising</h3>
          <p>Get immediate access to topic-specific tests online or offline.</p>
        </div>
      </div>
      <div class="tt-how-cta">
        <button class="tt-btn-primary" (click)="scrollToCalendar()">Register for Topic Tests Now</button>
      </div>
    </div>
  </section>

  <!-- ======================== FEATURES ======================== -->
  <section class="tt-section tt-features" id="features">
    <div class="tt-wrap">
      <div class="tt-features-layout">
        <div class="tt-features-left">
          <div class="tt-tag">Your 11+ Prep, Organised</div>
          <h2 class="tt-section-title">Everything Your Child Needs to Succeed</h2>
          <p class="tt-section-desc">Our topic tests are more than practice papers — they're a complete, structured preparation system designed around the actual exam syllabus.</p>
        </div>
        <div class="tt-features-grid">
          <div class="tt-feature-card">
            <div class="tt-feature-icon">🔍</div>
            <div>
              <h3>Identify Weak Areas</h3>
              <p>Focused questions highlight where improvement is needed most.</p>
            </div>
          </div>
          <div class="tt-feature-card">
            <div class="tt-feature-icon">📊</div>
            <div>
              <h3>Result Analysis Report (RAR)</h3>
              <p>Track progress and understand strengths and gaps over time.</p>
            </div>
          </div>
          <div class="tt-feature-card">
            <div class="tt-feature-icon">🏆</div>
            <div>
              <h3>Confidence Boost</h3>
              <p>Step-by-step readiness for full Mock Tests, week by week.</p>
            </div>
          </div>
          <div class="tt-feature-card">
            <div class="tt-feature-icon">📚</div>
            <div>
              <h3>Syllabus Coverage</h3>
              <p>Every topic in Maths, English, Creative Writing, VR &amp; NVR covered.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- ======================== CALENDAR / SESSION LIST ======================== -->

  <!-- Section heading -->
  <div class="tt-cal-heading" id="calendar-section">
    <div class="tt-wrap">
      <div class="tt-tag" style="justify-content:center;display:flex">Weekly Session Plan</div>
      <h2 class="tt-section-title tt-section-title--light" style="text-align:center">Book a Topic Test <span>Session</span></h2>
      <p style="text-align:center;font-size:15px;color:rgba(255,255,255,.52);margin-top:8px">
        Use the filters to find your session, then click <strong style="color:var(--tt-gold)">Book Now →</strong> to register
      </p>
    </div>
  </div>

  <!-- STICKY FILTER BAR -->
  <div class="tt-filterbar">
    <div class="tt-filterbar-main">
      <div class="tt-wrap">
        <div class="tt-filters-row">

          <!-- Search -->
          <div class="tt-fg tt-fg--search">
            <label class="tt-flabel">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
              Search
            </label>
            <input type="text" class="tt-finput"
                   placeholder="Name, location, exam board..."
                   [(ngModel)]="filters.search" (input)="applyFilters()" />
          </div>

          <!-- Centre -->
          <div class="tt-fg">
            <label class="tt-flabel">Centre</label>
            <select class="tt-fselect" [(ngModel)]="filters.center" (change)="applyFilters()">
              <option [ngValue]="null">Any Centre</option>
              <option *ngFor="let c of centers" [ngValue]="c">{{ c }}</option>
            </select>
          </div>

          <!-- Board -->
          <div class="tt-fg">
            <label class="tt-flabel">Exam Board</label>
            <select class="tt-fselect" [(ngModel)]="filters.pattern" (change)="applyFilters()">
              <option [ngValue]="null">All Boards</option>
              <option *ngFor="let p of patternTypes" [ngValue]="p.type_id">{{ p.type }}</option>
            </select>
          </div>

          <!-- Mode toggle -->
          <div class="tt-fg tt-fg--mode">
            <label class="tt-flabel">Mode</label>
            <div class="tt-mode-toggle">
              <button class="tt-mode-btn tt-mode-btn--f2f"
                      [class.tt-mode-btn--active]="filters.mode === 'Classroom Session'"
                      (click)="setMode('Classroom Session')">
                <span class="tt-mode-dot"></span> Face to Face
              </button>
              <button class="tt-mode-btn tt-mode-btn--online"
                      [class.tt-mode-btn--active]="filters.mode === 'Online Session'"
                      (click)="setMode('Online Session')">
                <span class="tt-mode-dot"></span> Online
              </button>
              <button class="tt-mode-btn tt-mode-btn--all"
                      [class.tt-mode-btn--active]="!filters.mode"
                      (click)="setMode(null)">
                All
              </button>
            </div>
          </div>

          <!-- Reset -->
          <button class="tt-freset" (click)="resetFilters()">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            Reset
          </button>

        </div>
      </div>
    </div>

    <!-- Active pills -->
    <div class="tt-filterbar-pills" *ngIf="filters.pattern || filters.mode || filters.center || filters.search">
      <div class="tt-wrap">
        <div class="tt-pills-row">
          <span class="tt-pills-label">Active filters:</span>
          <span class="tt-pill" *ngIf="filters.pattern">
            Board <button class="tt-pill-x" (click)="filters.pattern=null;applyFilters()">✕</button>
          </span>
          <span class="tt-pill" *ngIf="filters.mode">
            {{ filters.mode === 'Online Session' ? 'Online' : 'Face to Face' }}
            <button class="tt-pill-x" (click)="setMode(null)">✕</button>
          </span>
          <span class="tt-pill" *ngIf="filters.center">
            {{ filters.center }} <button class="tt-pill-x" (click)="filters.center=null;applyFilters()">✕</button>
          </span>
          <span class="tt-pill" *ngIf="filters.search">
            "{{ filters.search }}" <button class="tt-pill-x" (click)="filters.search='';applyFilters()">✕</button>
          </span>
          <span class="tt-count">{{ testList?.length || 0 }} session{{ testList?.length !== 1 ? 's' : '' }} found</span>
        </div>
      </div>
    </div>
  </div>

  <!-- SESSION LIST -->
  <section class="tt-sessions">
    <div class="tt-wrap">

      <!-- Sort bar -->
      <div class="tt-sortbar">
        <span class="tt-sortbar-count" *ngIf="testList?.length > 0">
          Showing <strong>{{ testList.length }}</strong> session{{ testList.length !== 1 ? 's' : '' }}
        </span>
        <div class="tt-sortbar-right">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="21" y1="10" x2="3" y2="10"/><line x1="21" y1="6" x2="3" y2="6"/><line x1="21" y1="14" x2="3" y2="14"/><line x1="21" y1="18" x2="3" y2="18"/></svg>
          Sorted by date (earliest first)
        </div>
      </div>

      <!-- CARDS -->
      <ng-container *ngIf="testList && testList.length > 0; else ttEmpty">

        <div class="tt-scard" *ngFor="let t of testList" [class.tt-scard--range]="isRangeDate(t.test_date)">

          <span style="display:none">{{ t.test_name }} {{ t.course }} {{ t.category }} {{ t.type }} {{ t.all_location || t.location }}</span>

          <!-- Date panel -->
          <div class="tt-scard-date" [class.tt-scard-date--range]="isRangeDate(t.test_date)" [class.tt-scard-date--tbd]="!hasDate(t.test_date)">
            <ng-container *ngIf="hasDate(t.test_date); else noDate">
              <span class="tt-scard-from" *ngIf="isRangeDate(t.test_date)">From</span>
              <span class="tt-scard-day">{{ getDateDay(t.test_date) }}</span>
              <span class="tt-scard-mon">{{ getDateMon(t.test_date) }}</span>
              <span class="tt-scard-yr">{{ getDateYr(t.test_date) }}</span>
            </ng-container>
            <ng-template #noDate>
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="opacity:.55"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              <span class="tt-scard-tbd">TBC</span>
            </ng-template>
          </div>

          <!-- Info -->
          <div class="tt-scard-info">
            <div class="tt-scard-top">
              <a class="tt-scard-cat" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
                {{ trimChar(t.category) }}
              </a>
              <span class="tt-scard-mode" [class.tt-scard-mode--online]="t.exam_type === 'Online Session'" [class.tt-scard-mode--f2f]="t.exam_type !== 'Online Session'">
                <span class="tt-mode-dot-sm"></span>
                {{ t.exam_type === 'Online Session' ? 'Online' : 'Face to Face' }}
              </span>
            </div>
            <a class="tt-scard-type" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ trimChar(t.type) }}</a>
            <a class="tt-scard-name" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">{{ t.test_name }}</a>
            <div class="tt-scard-loc" *ngIf="t.location || t.all_location">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              {{ trimChar(t.all_location || t.location) }}
            </div>
          </div>

          <!-- Price -->
          <div class="tt-scard-price">
            <ng-container *ngIf="t.payment_method === 'Free'; else priced">
              <span class="tt-price-free">Free</span>
            </ng-container>
            <ng-template #priced>
              <span class="tt-price-val">£{{ t.test_fees }}</span>
              <span class="tt-price-lbl">per child</span>
            </ng-template>
          </div>

          <!-- Book -->
          <div class="tt-scard-book">
            <a class="tt-book-btn" [routerLink]="['/11plus-help-club/category/', t.category_slug, t.test_slug]">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              Book Now
            </a>
          </div>

        </div>

        <!-- Load more -->
        <div class="tt-loadmore">
          <button class="tt-loadmore-btn" (click)="loadMore()">Load More Sessions</button>
        </div>

      </ng-container>

      <!-- Empty state -->
      <ng-template #ttEmpty>
        <div class="tt-empty">
          <div class="tt-empty-ico">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"/><path d="M21 21l-4-4"/></svg>
          </div>
          <h3 class="tt-empty-title">No sessions match your filters</h3>
          <p class="tt-empty-sub">Try widening your search or removing some filters</p>
          <button class="tt-empty-reset" (click)="resetFilters()">Clear All Filters</button>
        </div>
      </ng-template>

    </div>
  </section>

  <!-- ======================== TESTIMONIALS ======================== -->
  <section class="tt-section tt-testi" id="testimonials">
    <div class="tt-wrap">
      <div class="tt-section-hd tt-section-hd--center">
        <div class="tt-tag">What Parents Say</div>
        <h2 class="tt-section-title">Trusted by Families Across the UK</h2>
      </div>
      <div class="tt-testi-grid">
        <div class="tt-tcard" *ngFor="let t of testimonials">
          <div class="tt-tcard-quote">"</div>
          <div class="tt-tcard-stars">★★★★★</div>
          <p class="tt-tcard-text">{{ t.text }}</p>
          <div class="tt-tcard-author">— {{ t.name }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ======================== FAQ ======================== -->
  <section class="tt-section tt-faq" id="faq">
    <div class="tt-wrap">
      <div class="tt-section-hd">
        <div class="tt-tag">FAQ</div>
        <h2 class="tt-section-title tt-section-title--light">Have Questions?</h2>
      </div>
      <div class="tt-faq-list">
        <div class="tt-faq-item" *ngFor="let f of faqs; let i = index" [class.tt-faq-item--open]="openFaq === i">
          <button class="tt-faq-q" (click)="toggleFaq(i)">
            {{ f.q }}
            <svg class="tt-faq-chev" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <div class="tt-faq-a">{{ f.a }}</div>
        </div>
      </div>
    </div>
  </section>

  <!-- ======================== CTA ======================== -->
  <section class="tt-cta">
    <div class="tt-wrap" style="text-align:center">
      <h2 class="tt-cta-title">Start Your 11+ Journey Today</h2>
      <p class="tt-cta-sub">Register now and get immediate access to your first weekly topic test.</p>
      <div class="tt-cta-group">
        <button class="tt-btn-primary" (click)="scrollToCalendar()">Register for Topic Tests Now</button>
        <button class="tt-btn-outline" (click)="downloadCalendar()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="7 10 12 15 17 10"/><line x1="12" y1="15" x2="12" y2="3"/></svg>
          Download Schedule
        </button>
      </div>
    </div>
  </section>

  <!-- ======================== CONTACT ======================== -->
  <div class="tt-contact">
    <div class="tt-wrap">
      <div class="tt-contact-inner">
        <p class="tt-contact-title">Still have questions? We're here to help.</p>
        <div class="tt-contact-links">
          <a href="tel:+447464772331" class="tt-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.36 2 2 0 0 1 3.6 1.18h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.84a16 16 0 0 0 6 6l.91-.91a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7a2 2 0 0 1 1.72 2.03z"/></svg>
            +44 7464 772331
          </a>
          <a href="mailto:academy@sehyog.co.uk" class="tt-contact-link">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg>
            academy@sehyog.co.uk
          </a>
        </div>
      </div>
    </div>
  </div>

</div>